module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "width": "550px",
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "oldpass",
      "label-width": "100px",
      "label": "原密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "原密码",
      "show-password": ""
    },
    model: {
      value: (_vm.ruleForm2.oldpass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "oldpass", $$v)
      },
      expression: "ruleForm2.oldpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "prop": "newpass",
      "label-width": "100px",
      "label": "新密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "新密码",
      "show-password": ""
    },
    model: {
      value: (_vm.ruleForm2.newpass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "newpass", $$v)
      },
      expression: "ruleForm2.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newlpass",
      "label-width": "100px",
      "label": "新密码确认"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "新密码确认",
      "show-password": ""
    },
    model: {
      value: (_vm.ruleForm2.newlpass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "newlpass", $$v)
      },
      expression: "ruleForm2.newlpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("确认修改")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93856fd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/changpwd.vue
// module id = 389
// module chunks = 55